<template>
    <rkm-overlay>
         <rkm-layout-body title="Relatório de Atividade Coletiva">
            <rkm-layout-content>
                 <List />
            </rkm-layout-content>
            
         </rkm-layout-body>
    </rkm-overlay>
</template>


<script>
import List from '@/components/atencao-basica/relatorio-atividade-coletiva/List'
export default {
    components:{ List }
}
</script>